export const colorMap = {
  secondary: {
    base: '#f97316',
    hover: '#ea580c',
    light: '#fdba74',
    dark: '#c2410c',
  },
  primary: {
    base: '#22c55e',
    hover: '#16a34a',
    light: '#86efac',
  },
  accent: {
    base: '#3b82f6', // Bleu pour WhatsApp
    hover: '#2563eb',
    light: '#93c5fd',
  },
  text: {
    primary: '#111827',
    secondary: '#6b7280',
    muted: '#9ca3af',
    dark: '#374151',
  },
  bg: {
    white: '#ffffff',
    light: '#f9fafb',
    card: '#ffffff',
  },
  border: {
    default: '#e5e7eb',
  },
};
